module.exports = __webpack_public_path__ + "img/waiter.01ae8579.svg";